import { differenceInDays, format, formatRelative } from "date-fns";
import { capitalize } from "lodash";
import { EmptyCell } from "./EmptyCell";
import { unreachableCase } from "../../../utils";

type DateFormat = "date" | "datetime" | "relativetime";

function formatDateForType(date: Date, type: DateFormat) {
  if (type === "date") {
    return format(date, "PP");
  }
  if (type === "datetime") {
    return format(date, "PPp");
  }
  if (type === "relativetime") {
    const now = new Date();
    const diff = differenceInDays(now, date);
    return diff <= 5
      ? capitalize(formatRelative(date, now))
      : format(date, "PPp");
  }
  return unreachableCase(type);
}

export const DateCell: React.FC<{
  value: any;
  type: DateFormat;
}> = ({ value, type }) => {
  const d = new Date(value);
  return !value || isNaN(d.getTime()) ? (
    <EmptyCell />
  ) : (
    <span title={d.toISOString()}>{formatDateForType(d, type)}</span>
  );
};
